import * as React from 'react';
import { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { Loading } from 'src/components/common/loading/Loading';
import { useIdentity } from 'src/hooks/useIdentity';
import { ampli } from 'src/lib/analytics/amplitude/vendor';
import { useLDIdentityType } from 'src/lib/launchDarkly/LaunchDarklyProvider';
import { LaunchDarklyIdentityTypes } from 'src/lib/launchDarkly/types';

import * as routes from '../../routes/routes';

import { CreateAccountCTA } from './components/CreateAccountCTA';

export const Signup = () => {
  const location = useLocation();
  const { me, meLoading } = useIdentity();
  const launchDarklyIdentityType = useLDIdentityType();

  useEffect(() => {
    // Amplitude will be disabled by default until LaunchDarklyIdentityType
    // resolves.
    if (launchDarklyIdentityType !== LaunchDarklyIdentityTypes.unknown) {
      // me is undefined until useIdentity resolves, then convert to null if the user is unknown
      if (me !== undefined) {
        ampli.registrationOpened({
          RegistrationVariant: 'studio-direct',
          RegistrationPath: 'frontdoor-signup',
        });
      }
    }
  }, [launchDarklyIdentityType, me]);

  if (meLoading) return <Loading />;

  if (me?.__typename === 'User') {
    // Already logged in
    return (
      <Redirect
        to={routes.welcome.locationFrom({
          location,
          fromRouteConfig: routes.signup,
        })}
      />
    );
  }

  return (
    <CreateAccountCTA
      emailTo={routes.welcome.locationFrom({
        fromRouteConfig: routes.signup,
        location,
      })}
      callbackURL={routes.welcome.pathFrom({
        fromRouteConfig: routes.signup,
        location,
      })}
      title="Get started with Apollo 🚀"
      description="Connect your GraphQL API to create a single source of truth for your schema, validate every change you make to it, and visualize the performance of your queries."
    />
  );
};
